import { Component, ReactNode } from 'react';
import { connect } from 'react-redux';

// import DropList from 'components/atoms/DropList'
import TabsLayout from 'components/atoms/TabsLayout';
import { bindActionCreators, Dispatch } from 'redux';
import { transitUpdate } from 'services/transits';
import { SetErrorHandlerAction, setErrorHandlerAction } from 'store/actions/errorsActions';
import { CommentType, OpenModal, PortType, RootState, TagType, TransitType, UserCommentType } from 'types';
import { MainControlsInterface } from 'types/functions';
import { ActionsType } from 'types/system';
import { checkDifferent } from 'utils/formHandlers';
import { formatServerErrors } from 'utils/formatServerErrors';

import CommentsTab from './tabs/CommentsTab';
import TagsTab from './tabs/TagsTab';

interface AllTransitTagsAndCommentsModelProps {
    //unused props
    openModelFunction: OpenModal;

    id?: string;
    data: any;

    actions: ActionsType | undefined;
    action?: (data: CommentType, index?: string) => void;

    //unused props
    language?: string;
    tags: TagType[];
    mainControls: MainControlsInterface;
    port: PortType;
    setErrorHandlerAction: SetErrorHandlerAction;
}

interface AllTransitTagsAndCommentsModelState {
    tabs: { [key: string]: ReactNode };
    errors: any;
    activeTab: string;
    edit: boolean;
    data: any;
    loading: boolean;
    comment: UserCommentType;
    selectedTags: { id: number | string; type: string; usedForAll: boolean }[];
    sourceSelectedTags: { id: number | string; type: string; usedForAll: boolean }[];
}

class AllTransitTagsAndCommentsModel extends Component<
    AllTransitTagsAndCommentsModelProps,
    AllTransitTagsAndCommentsModelState
> {
    constructor(props: AllTransitTagsAndCommentsModelProps) {
        super(props);
        this.state = {
            tabs: {},
            data: {},
            activeTab: 'tags',
            errors: {},
            loading: false,
            edit: false,
            comment: {
                text: '',
                type: 'private',
            },
            selectedTags: [],
            sourceSelectedTags: [],
        };
    }

    componentDidMount(): void {
        const { transits } = this.props.mainControls.getTransit(0);
        const filterTransits = transits.filter((x: TransitType) => {
            return x.options.select;
        });
        const transitTags = filterTransits.map((transit: TransitType) => {
            return transit.transit_tags
                .filter((tag) => {
                    return tag.tag.type === 'public' || tag.tag.type === 'private' || tag.tag.type === 'analysis';
                })
                .map((tag) => {
                    const t = this.props.tags.find((x) => {
                        return x.id === tag.tag_id;
                    });
                    //@ts-ignore
                    return { id:  t?.id || 0 , type: t?.type || "" };
                }).filter((x) => {
                    return x.id !== 0;
                });
        });

        const uniqueTags = Array.from(new Map(transitTags.flat().map((tag) => [tag.id, tag])).values());

        const selectedTags = uniqueTags.map((tag) => ({
            id: tag.id,
            type: tag.type,
            usedForAll: transitTags.every((subArray) => subArray.some((t) => t.id === tag.id)),
        }));

        this.setState({ selectedTags , sourceSelectedTags : [...selectedTags] }, this.renderData);
    }

    handleFormSubmit = (e: React.FormEvent<HTMLFormElement>) => {
        e?.preventDefault();
        this.save();
        //this.props.actions.onCancel();
    };

    handleFormCancel = (e: React.FormEvent<HTMLFormElement>) => {
        e?.preventDefault();
        this.props.actions?.onCancel();
    };

    handleFormClear = () => {
        this.setState(
            {
                selectedTags: [...this.state.sourceSelectedTags],
            },
            this.renderData
        );
    };

    handleClose = () => {
        this.setState({
            errors: {},
        });
    };

    setTag = (id: number | string, type: string) => {
        this.setState((prevState) => {
            const existingTag = prevState.selectedTags.find((tag) => tag.id === id);

            let updatedTags;

            if (!existingTag) {
                // Add new tag
                updatedTags = [...prevState.selectedTags, { id, type, usedForAll: true }];
            } else if (!existingTag.usedForAll) {
                // Change false -> true
                updatedTags = prevState.selectedTags.map((tag) => (tag.id === id ? { ...tag, usedForAll: true } : tag));
            } else {
                // Remove tag
                updatedTags = prevState.selectedTags.filter((tag) => tag.id !== id);
            }

            return { selectedTags: updatedTags };
        }, this.renderData);
    };

    setComment = (text: string, type: string) => {
        this.setState(
            {
                comment: { text, type },
            },
            this.renderData
        );
    };

    componentDidUpdate(prevProps: AllTransitTagsAndCommentsModelProps, prevState: AllTransitTagsAndCommentsModelState) {
        if (checkDifferent(prevState.data, this.state.data) || checkDifferent(prevState.errors, this.state.errors)) {
            this.renderData();
        }
    }

    onTabChange = (tab: string, nextTab: string) => {
        this.setState({ activeTab: nextTab });
        return true;
    };

    save = () => {
        // Extract selected transits

        const { transits } = this.props.mainControls.getTransit(0);
        const selectedTransits = transits.filter((transit: TransitType) => transit.options.select);

        // Map transits to tags to save
        const tagsToSave = selectedTransits.map((transit) => {
            const currentTagIds = transit.transit_tags
                .filter((tag) => tag.tag.type === 'public' || tag.tag.type === 'private' || tag.tag.type === 'analysis')
                .map((tag) => {
                    return tag;
                });

            const tagsToDelete = currentTagIds
                .filter((tag) => {
                    return !this.state.selectedTags.some(
                        (a) => a.id === ( tag.tag.id)
                    );
                })
                .map((tag) => ({
                    id:   tag.tag.id,
                    status: 'delete',
                    type: tag.type === 'analysis' ? 'analysis' : 'user',
                }));

            const tagsToAdd = this.state.selectedTags
                .filter(
                    (tag) =>
                        tag.usedForAll &&
                        !currentTagIds
                            .map((a) => (  a.tag.id))
                            .includes(tag.id)
                )
                .map((tag) => ({ id: tag.id, status: 'add', type: tag.type === 'analysis' ? 'analysis' : 'user' }));

            return { id: transit.id, tags: [...tagsToDelete, ...tagsToAdd] };
        });
        // Update state and call API
        this.setState({ errors: {}, loading: true }, () => {
            transitUpdate(this.props.port.id, { comment: this.state.comment, transits: tagsToSave })
                .then(() => {
                    const updatedTransitIds = selectedTransits.map((transit) => transit.id);

                    this.props.mainControls.updateTransits(updatedTransitIds, [
                        'transit_tags',
                        'tag_slugs',
                        'comments',
                    ]);
                    this.props.actions?.onCancel();
                })
                .catch((errors) => {
                    const { response } = errors;

                    if (response?.status === 422) {
                        this.setState({ errors: formatServerErrors(errors), loading: false });
                    } else {
                        this.setState({ loading: false });
                        this.props.setErrorHandlerAction(errors);
                    }
                });
        });
    };

    renderData = () => {
        this.setState({
            tabs: {
                tags: (
                    <TagsTab
                        key={0}
                        selectedTags={this.state.selectedTags}
                        errors={this.state.errors}
                        setTag={this.setTag}
                        actions={this.props.actions}
                    ></TagsTab>
                ),
                comments: (
                    <CommentsTab
                        key={1}
                        many={true}
                        comment={this.state.comment}
                        errors={this.state.errors}
                        setComment={this.setComment}
                        actions={this.props.actions}
                    ></CommentsTab>
                ),
            },
        });
    };

    render() {
        return (
            <>
                <TabsLayout
                    activeTab={this.state.activeTab}
                    onTabChange={this.onTabChange}
                    tabs={this.state.tabs}
                    model="AllTransitTagsAndCommentsModel"
                    actions={{
                        onCancel: this.handleFormCancel,
                        onConfirm: this.handleFormSubmit,
                        onClear: this.handleFormClear,
                    }}
                />
            </>
        );
    }
}

const mapStateToProps = (state: RootState) => ({
    openModelFunction: state.layout.openModelFunction,
    mainControls: state.layout.mainControls,
    port: state.port.port,
    tags: state.port.tags,
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
    setErrorHandlerAction: bindActionCreators(setErrorHandlerAction, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(AllTransitTagsAndCommentsModel);
